<template>
  <v-app>
    <v-app-bar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>BUSZ</span>
        <span class="font-weight-light">MENETREND</span>
        <span>2</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="map = !map"><v-icon>mdi-map-search</v-icon></v-btn>
    </v-app-bar>

    <v-content>
      <TimeTable v-if="!map"/>
      <iframe class="iframe" v-if="map" src="https://www.google.com/maps/d/u/0/embed?mid=1jsFzYXQxNwbFCx6ezcXOLkUi28MjMOei"></iframe>
    </v-content>
  </v-app>
</template>

<script>
import TimeTable from './components/TimeTable';

export default {
  name: 'App',
  components: {
    TimeTable,
  },
  data: () => ({
    map: false,
    //
  }),
};
</script>

<style scoped>
.iframe {
  border: none;
  height: 100%;
  width: 100%;
}
.v-content {
  overflow: hidden;
}
</style>